<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        isProductClassSelected ? 'selected' : ''
      ]"
      @click="form.showProductClassModal = true"
    >
      Product class
    </button>

    <b-modal
      id="modal-productclass"
      v-model="form.showProductClassModal"
      :no-close-on-backdrop="true"
      size="lg"
      title="Choose Product Class"
      @ok="saveProductClasses"
      @show="showModal"
      @hide="onHidden"
    >
      <b-tabs content-class="px-2">
        <b-tab title="Product class">
          <div class="form-row">
            <div class="col-sm-4">
              <b-form-select
                v-model="productName1"
                class="my-4"
                size="sm"
                :options="productName1Options"
              />
            </div>
            <div class="col-sm-4">
              <b-form-select
                v-model="productName2"
                class="my-4"
                size="sm"
                :options="productName2Options"
                :disabled="!productName2Options.length"
              />
            </div>
            <div class="col-sm-4">
              <b-form-select
                v-model="productName3"
                class="my-4"
                size="sm"
                :options="productName3Options"
                :disabled="!productName3Options.length"
              />
            </div>

            <div class="col-sm-12">
              <b-button
                variant="success btn-sm"
                class="my-4"
                :disabled="!productName1"
                @click="addProductClass"
              >
                Add
              </b-button>
              <b-button
                v-if="temporaryProductClasses.length > 1"
                class="my-4 ml-2"
                variant="danger"
                size="sm"
                @click="removeProductClasses"
              >
                Remove all
              </b-button>
            </div>
            <b-list-group class="col-sm-12">
              <b-list-group-item
                v-for="(productclass, index) in temporaryProductClasses"
                :key="index"
              >
                <span>{{ stringifyProductClass(productclass) }}</span>
                <b-button
                  class="ml-2 float-right"
                  variant="danger"
                  size="sm"
                  @click="removeProductClass(index)"
                >
                  Remove
                </b-button>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-tab>
      </b-tabs>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import { search } from '../../../assets/js/api.js';


export default {
  name: "ProductClassModal",
  props: {
      form: Object,
  },
  data() {
    return {
      productName1: null,
      productName2: null,
      productName3: null,
      temporaryProductClasses: [],
      confirmDialogId: "modal-productclass",
      productClasses:[]
    };
  },


  computed: {
    isProductClassSelected(){
      let query = this.$store.getters['campaignApiBody/getPayload'];
      return query.productClasses.length > 0
    },
    productName1Options() {
      let productName1Options = [
        ...new Set(this.productClasses.map(p => p.productName1))
      ].sort();
      return [
        { value: null, text: "Choose an option" },
        ...productName1Options
      ];
    },
    productName2Options() {
      let productName2Options = this.productClasses
        .filter(
          p => p.productName1 == this.productName1 && p.productName2 !== "-"
        )
        .map(p => p.productName2);
      let productName2OptionsDistinct = [
        ...new Set(productName2Options)
      ].sort();
      if (productName2OptionsDistinct.length > 0)
        productName2OptionsDistinct.unshift({
          value: null,
          text: "Choose an option"
        });
      return productName2OptionsDistinct;
    },
    productName3Options() {
      let productName3Options = [
        this.productClasses
          .filter(
            p =>
              p.productName1 == this.productName1 &&
              p.productName2 == this.productName2 &&
              p.productName3 !== "-"
          )
          .map(p => p.productName3)
      ];
      let productName3OptionsDistinct = [
        ...new Set(...productName3Options)
      ].sort();
      if (productName3OptionsDistinct.length > 0)
        productName3OptionsDistinct.unshift({
          value: null,
          text: "Choose an option"
        });
      return productName3OptionsDistinct;
    }
  },
  watch: {
    productName1() {
      this.productName2 = null;
    },
    productName2() {
      this.productName3 = null;
    }
  },
    created(){
        this.fetchProductClasses();
  },
  methods: {
    savedProductClasses() {
      this.$store.commit('campaignApiBody/updateProductClasses',[...this.temporaryProductClasses]);
    },
    onKeyUp(event) {
        if (
          event.key === "Enter" &&
          this.form.showProductClassModal
        ) {
          this.saveProductClasses();
          this.form.showProductClassModal= false;
        }
    },
    async fetchProductClasses()
    {
        let pc = await search("Spot/GetProductClasses")  
        this.productClasses = pc;              
    },
    onHidden() {
      document.removeEventListener("keyup", this.onKeyUp);
    },
    confirmDialog(e) {
      if (e.trigger == "ok") this.$bvModal.hide("modal-productclass");
    },
    showModal() {
      document.addEventListener("keyup", this.onKeyUp);
      this.productName1 = null;
      let storedProductClasses = [...this.$store.state.campaignApiBody.payload.productClasses];

      this.temporaryProductClasses = storedProductClasses;
    },
    addProductClass() {
      const config = {
        productName1: this.productName1,
        productName2: this.productName2,
        productName3: this.productName3
      };

      if (
        this.temporaryProductClasses.filter(
          g =>
            g.productName1 === config.productName1 &&
            g.productName2 === config.productName2 &&
            g.productName3 === config.productName3
        ).length !== 0
      ) {
        this.$bvToast.toast("The product class already exists", {
          title: "Warning",
          variant: "warning",
          solid: true,
          autoHideDelay: 3000
        });
      } else {
        this.temporaryProductClasses.push(config);
      }
    },
    removeProductClass(index) {
      this.temporaryProductClasses.splice(index, 1);
    },
    removeProductClasses() {
      this.temporaryProductClasses = [];
    },
    stringifyProductClass(productClass) {
      return [
        productClass.productName1,
        productClass.productName2,
        productClass.productName3
      ]
        .filter(x => x)
        .join("; ");
    },
    saveProductClasses() {    
        this.$store.commit('campaignApiBody/updateProductClasses', this.temporaryProductClasses); 
    }
  }
};
</script>

<style scoped>
label {
  width: 100%;
}

.selectedItemsClass {
  background-color: #e5f3ff;
  border-color: #337ab7;
  color: #6c757d;
}
</style>
